// Ported from the Software (Piping/ParentTabsTest/pipingRevisions.js): the part
// that reads a saved revision payload. The web used to take `raw.data` as-is,
// which comes back empty for the stringified and double-wrapped shapes the
// Software also saves - so a Spec record written there loaded as blank here.

const INSTRUMENTATION_REVISION_DATA_KEYS = [
  "selectedSpecs",
  "customSpecRows",
  "specHelperConfigs",
  "partLibTable",
  "SelectedParts",
  "pdcAttachItems",
  "modelingData",
  "hookupsTable",
  "projectPath",
  "tagNumbersList",
  "selectedLineNumber",
  "estimationTable",
  "pnidData",
  "pnidProjectPath",
  "pnidRevisionFolders",
  "pnidFolderTree",
  "selectedPnidRevision",
  "UID_array",
  "__pipingProjectRevisionDeleted",
];

const parseMaybeJson = (value) => {
  if (typeof value !== "string") return value;

  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

/**
 * Normalize the equivalent payload shapes returned by the revision endpoints.
 * Piping revisions have historically been returned either directly under
 * `data`, JSON-stringified under `data`, or wrapped once in the normal
 * { name, type, revision, data } save payload.
 */
export const extractInstrumentationRevisionData = (sourcePayload) => {
  let current = parseMaybeJson(sourcePayload?.data ?? sourcePayload ?? {});

  for (let depth = 0; depth < 3; depth += 1) {
    if (!current || typeof current !== "object" || Array.isArray(current)) {
      return {};
    }

    const isInstrumentationData = INSTRUMENTATION_REVISION_DATA_KEYS.some((key) =>
      Object.prototype.hasOwnProperty.call(current, key),
    );

    if (isInstrumentationData) return current;

    const nested = parseMaybeJson(current.data);
    if (!nested || nested === current) break;
    current = nested;
  }

  return current && typeof current === "object" && !Array.isArray(current)
    ? current
    : {};
};
